/* tslint:disable */
/* eslint-disable */
/**
 * RZPV API
 * API rozklikávacího rozpočtu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumPlanObdobi } from '../model';
// @ts-ignore
import { PlanVO } from '../model';
/**
 * StatistikaControllerApi - axios parameter creator
 * @export
 */
export const StatistikaControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {boolean} pdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStatsExportFile: async (fileId: string, pdf: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadStatsExportFile', 'fileId', fileId)
            // verify required parameter 'pdf' is not null or undefined
            assertParamExists('downloadStatsExportFile', 'pdf', pdf)
            const localVarPath = `/api/rzpv/statistika/export/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pdf !== undefined) {
                localVarQueryParameter['pdf'] = pdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {boolean} pdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStatistika: async (idPlanVerze: number, planObdobi: EnumPlanObdobi, pdf: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('exportStatistika', 'idPlanVerze', idPlanVerze)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('exportStatistika', 'planObdobi', planObdobi)
            // verify required parameter 'pdf' is not null or undefined
            assertParamExists('exportStatistika', 'pdf', pdf)
            const localVarPath = `/api/rzpv/statistika/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }

            if (pdf !== undefined) {
                localVarQueryParameter['pdf'] = pdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistika: async (idPlanVerze: number, planObdobi: EnumPlanObdobi, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('getStatistika', 'idPlanVerze', idPlanVerze)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('getStatistika', 'planObdobi', planObdobi)
            const localVarPath = `/api/rzpv/statistika`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatistikaControllerApi - functional programming interface
 * @export
 */
export const StatistikaControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatistikaControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {boolean} pdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadStatsExportFile(fileId: string, pdf: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadStatsExportFile(fileId, pdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {boolean} pdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, pdf: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportStatistika(idPlanVerze, planObdobi, pdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatistika(idPlanVerze, planObdobi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatistikaControllerApi - factory interface
 * @export
 */
export const StatistikaControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatistikaControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {boolean} pdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStatsExportFile(fileId: string, pdf: boolean, options?: any): AxiosPromise<any> {
            return localVarFp.downloadStatsExportFile(fileId, pdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {boolean} pdf 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, pdf: boolean, options?: any): AxiosPromise<string> {
            return localVarFp.exportStatistika(idPlanVerze, planObdobi, pdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<PlanVO>> {
            return localVarFp.getStatistika(idPlanVerze, planObdobi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatistikaControllerApi - interface
 * @export
 * @interface StatistikaControllerApi
 */
export interface StatistikaControllerApiInterface {
    /**
     * 
     * @param {string} fileId 
     * @param {boolean} pdf 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikaControllerApiInterface
     */
    downloadStatsExportFile(fileId: string, pdf: boolean, options?: any): AxiosPromise<any>;

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {boolean} pdf 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikaControllerApiInterface
     */
    exportStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, pdf: boolean, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikaControllerApiInterface
     */
    getStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<PlanVO>>;

}

/**
 * StatistikaControllerApi - object-oriented interface
 * @export
 * @class StatistikaControllerApi
 * @extends {BaseAPI}
 */
export class StatistikaControllerApi extends BaseAPI implements StatistikaControllerApiInterface {
    /**
     * 
     * @param {string} fileId 
     * @param {boolean} pdf 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikaControllerApi
     */
    public downloadStatsExportFile(fileId: string, pdf: boolean, options?: any) {
        return StatistikaControllerApiFp(this.configuration).downloadStatsExportFile(fileId, pdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {boolean} pdf 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikaControllerApi
     */
    public exportStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, pdf: boolean, options?: any) {
        return StatistikaControllerApiFp(this.configuration).exportStatistika(idPlanVerze, planObdobi, pdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikaControllerApi
     */
    public getStatistika(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any) {
        return StatistikaControllerApiFp(this.configuration).getStatistika(idPlanVerze, planObdobi, options).then((request) => request(this.axios, this.basePath));
    }
}
